import { createLaravelHttpClient } from "@vadiun/http-client";
import environment from "environment/environment";

export const httpClient = createLaravelHttpClient({
  url: environment.backEnd,
  token: () => localStorage.getItem("token") ?? "",
});
